import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { UserStarIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { signUpHref } from '@/constants/authRoutes'

export const FormAccessRequired: React.FC<{
  title?: string
  description?: string
  /** Hide the Sign up / Sign in actions, e.g. for signed-in users lacking access. */
  showAuthActions?: boolean
}> = ({
  title = 'Join us or sign in to access this form.',
  description = 'Join the movement! Stay informed on all things MAHA, including the latest on the issues, MAHA events and updates, and more.',
  showAuthActions = true,
}) => {
  const pathname = usePathname()
  return (
    <div className="mx-auto flex max-w-sm items-center justify-center gap-2 rounded-2xl py-8 font-body lg:py-12 xl:py-16">
      <div className="flex flex-col items-center justify-center gap-4 text-center text-balance">
        <div className="flex size-14 items-center justify-center rounded-xl bg-evergreen-100 p-2">
          <UserStarIcon className="size-8 text-evergreen-800" />
        </div>
        <h3 className="text-2xl font-semibold text-foreground">{title}</h3>
        <p className="text-reg text-card-foreground">{description}</p>
        {showAuthActions && (
          <div className="flex items-center justify-center gap-2">
            <Button
              variant="accent"
              className="flex w-fit shrink-0 items-center whitespace-nowrap"
              asChild
            >
              <Link href={signUpHref(pathname)}>Sign up</Link>
            </Button>
            <Button
              variant="outline"
              className="flex w-fit shrink-0 items-center whitespace-nowrap"
              asChild
            >
              <Link href={`/sign-in?redirectTo=${pathname}`}>Sign in</Link>
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
